/* eslint-disable perfectionist/sort-enums */
export enum CanvasMode {
  Draw = 1,
  PathPreview = 2,
  CurveEngraving = 3,
  AutoFocus = 4,
}
